import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Compass, Brain, Briefcase, FileText, ArrowRight } from 'lucide-react';

const LandingCompass = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const cards = [
    { icon: Brain, emoji: '🧠', title: t('landing.compassCard1Title'), desc: t('landing.compassCard1Desc') },
    { icon: Briefcase, emoji: '🧭', title: t('landing.compassCard2Title'), desc: t('landing.compassCard2Desc') },
    { icon: FileText, emoji: '📖', title: t('landing.compassCard3Title'), desc: t('landing.compassCard3Desc') },
  ];

  return (
    <section className="py-20 sm:py-28 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-primary/5 via-transparent to-primary/5 pointer-events-none" />
      <div className="absolute top-1/2 start-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] max-w-[90vw] rounded-full bg-primary/5 blur-3xl pointer-events-none" />
      <div className="relative max-w-5xl mx-auto">
        <div className="text-center mb-12 space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-xs font-semibold text-primary">
            <Compass className="h-3.5 w-3.5" />
            Rutini Compass
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold leading-tight max-w-3xl mx-auto">
            {t('landing.compassTitle')}
          </h2>
          <p className="text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            {t('landing.compassIntro')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {cards.map((c, i) => (
            <Card key={i} className="border-primary/15 bg-card/70 backdrop-blur-sm hover:border-primary/30 hover:shadow-lg hover:shadow-primary/10 transition-all">
              <CardContent className="p-6 space-y-3">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center text-2xl" aria-hidden>
                  {c.emoji}
                </div>
                <h3 className="font-semibold text-base">{c.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{c.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="flex flex-col items-center gap-3">
          <Button
            variant="outline"
            size="lg"
            className="border-primary text-primary hover:bg-primary/10 min-h-[48px] rounded-full px-8"
            onClick={() => navigate('/auth')}
          >
            {t('landing.compassCta')}
            <ArrowRight className="ms-2 h-4 w-4" />
          </Button>
          <p className="text-xs text-muted-foreground italic text-center max-w-md">
            {t('landing.compassDisclaimer')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default LandingCompass;
